
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 97.637 97.637"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M97.523 18.526a.482.482 0 00-.568-.131 39.055 39.055 0 01-9.153 2.776 20.299 20.299 0 007.143-10.035.484.484 0 00-.709-.565 39.147 39.147 0 01-12.18 4.701 20.408 20.408 0 00-14.644-6.219c-11.204 0-20.318 9.114-20.318 20.317 0 1.355.131 2.697.391 4-15.518-.958-30.028-8.408-39.894-20.509a.484.484 0 00-.795.062 20.303 20.303 0 00-2.751 10.215 20.3 20.3 0 007.649 15.896 19.42 19.42 0 01-7.089-2.292.483.483 0 00-.721.413l-.002.26c0 8.946 5.895 16.801 14.282 19.409a19.514 19.514 0 01-6.754-.098.486.486 0 00-.553.623A20.314 20.314 0 0028.494 71.39c-6.785 4.971-14.805 7.59-23.279 7.59-1.561 0-3.133-.093-4.673-.274a.492.492 0 00-.514.317.485.485 0 00.195.572 56.693 56.693 0 0030.664 8.988c35.625 0 56.913-28.938 56.913-56.914 0-.779-.015-1.554-.046-2.327a40.519 40.519 0 009.802-10.235.486.486 0 00-.033-.581z","fill":"#FFF"}})])
          )
        }
      }
    